import { DreamValue } from '@/sharedComponents/TextEditor/plate';
import { v4 as uuid } from 'uuid';

export const generateLinkInBioTemplate = ({
  profilePic,
  profileName,
  profileBio,
  socials = {},
}: {
  profilePic?: string;
  profileName?: string;
  profileBio?: string;
  socials?: { [key: string]: string };
}): DreamValue => {
  let profileSocialLinks = Object.values(socials).map((url) => ({
    children: [
      {
        id: uuid(),
        text: '',
      },
    ],
    icon: '',
    id: uuid(),
    type: 'social_link_item',
    url,
  }));

  if (profileSocialLinks.length === 0) {
    profileSocialLinks = [
      {
        children: [
          {
            id: '35a3ff87-8c1c-453f-818d-b0c88947fef1',
            text: '',
          },
        ],
        icon: '',
        id: '44a7e6e7-8b17-47d9-aa03-51fc386d57ab',
        type: 'social_link_item',
        url: 'https://www.youtube.com/@typedream',
      },
      {
        children: [
          {
            id: 'c04a5dd7-d87c-43ab-b4c0-0c9f67e5d8fb',
            text: '',
          },
        ],
        icon: '',
        id: '4cc88b0d-82ae-4733-b16f-2b9fead2792e',
        type: 'social_link_item',
        url: 'https://www.tiktok.com/@typedream',
      },
      {
        children: [
          {
            id: '3bd0837a-8f96-48f5-9629-344b6e548d7f',
            text: '',
          },
        ],
        icon: 'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/logo/block_cloud_svg.webp',
        id: 'de6708b7-d086-46b8-92b1-2a9875ac5d12',
        type: 'social_link_item',
        url: 'http://typedream.com',
      },
    ];
  }
  const content: DreamValue = [
    {
      children: [
        {
          children: [
            {
              children: profileSocialLinks,
              id: '80e75b32-8cca-42d1-a158-7c9d162d0b38',
              type: 'social_links',
            },
          ],
          id: 'daf13260-b481-45b3-b949-3a53354eb7d1',
          type: 'profile',
          title: profileName || 'Jenn Miller',
          subtitle:
            profileBio ||
            'Founder turned 🎬 YouTuber (1m subs) → Helping you build your YouTube channel ⚙️',
          image:
            profilePic ||
            'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets/Female%20Memojis.png',
        },
        {
          children: [
            {
              backgroundVideo:
                'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets%2Finfluencer-hero-video.mp4',
              buttonText: 'My YouTube Channel →',
              children: [
                {
                  text: '',
                },
              ],
              gridProps: {
                h: 2,
                i: '.$daf1f80-b481-45b3-b949-3a53354eb7d1',
                moved: false,
                static: false,
                w: 1,
                x: 0,
                y: 0,
              },
              id: 'daf1f80-b481-45b3-b949-3a53354eb7d1',
              title: 'Explore strategies & tools to start a Creator Business',
              type: 'card_background',
            },
            {
              backgroundImage:
                'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets/CreatorAcademy.png',
              buttonText: 'Creator Academy 2023 →',
              children: [
                {
                  text: '',
                },
              ],
              gridProps: {
                h: 1,
                i: '.$daf1f81-b481-45b3-b949-3a53354eb7d1',
                moved: false,
                static: false,
                w: 1,
                x: 1,
                y: 1,
              },
              id: 'daf1f81-b481-45b3-b949-3a53354eb7d1',
              title: '',
              type: 'card_background',
            },
            {
              background:
                'radial-gradient(109.42% 248.28% at 0% 0%, #FFF6E8 0%, #FFC85D 33.33%, #FFB571 60.94%, #FFA2AD 100%)',
              buttonText: 'More courses',
              children: [
                {
                  arrowColor: '#785552',
                  children: [
                    {
                      id: 'e12bdc0c-d897-4ac8-bb2f-40f3e7cbba75',
                      text: '',
                    },
                  ],
                  id: '5fa1a379-1e2d-4481-9cb1-fe1f2a44c876',
                  imageUrl:
                    'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets/Product1-CrashCourse.png',
                  subtitle: 'Get started creating in 7 days',
                  title: 'Creatorpreneur Crash Course',
                  type: 'card_product_item',
                  url: '',
                },
                {
                  arrowColor: '#785552',
                  children: [
                    {
                      id: 'd6c35b3b-4892-47ba-8a74-bac45e3d3079',
                      text: '',
                    },
                  ],
                  id: '611bf481-e8b8-4d23-9e79-8b6c0b1d92c0',
                  imageUrl:
                    'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets/Product2-Camera.png',
                  subtitle: 'Get confident in front of a camera',
                  title: 'Camera Ready Course',
                  type: 'card_product_item',
                  url: '',
                },
                {
                  arrowColor: '#785552',
                  children: [
                    {
                      id: '8cd84f79-4e47-44a5-971e-403ddc11ef1d',
                      text: '',
                    },
                  ],
                  id: 'b8531e28-0a44-469d-a01d-638e39c88de9',
                  imageUrl:
                    'https://typedream-assets.sfo3.cdn.digitaloceanspaces.com/TemplateAssets/Product3-7Days.png',
                  subtitle: '1 hour a day to build your YouTube channel',
                  title: '7-Days YouTube Starter Pack',
                  type: 'card_product_item',
                  url: '',
                },
              ],
              gridProps: {
                h: 1,
                i: '.$d2abf305-3701-4780-ba30-c0f84cf75dcb',
                moved: false,
                static: false,
                w: 2,
                x: 1,
                y: 0,
              },
              id: 'd2abf305-3701-4780-ba30-c0f84cf75dcb',
              title: 'Creator Courses & Guides',
              type: 'card_product',
              url: 'https://typedream.com/blog',
            },
            {
              children: [
                {
                  children: [
                    {
                      id: '64edaf22-f737-498a-8745-845de92e6483',
                      text: '',
                    },
                  ],
                  data: {
                    bio: 'The Canva of web pages: build pages, link in bios, forms, blogs, shops - no code.',
                    followers: 15936,
                    following: 11,
                    username: '@typedreamhq',
                  },
                  gridProps: {
                    lg: {
                      h: 1,
                      w: 1,
                      x: 0,
                      y: 0,
                    },
                    md: {
                      h: 1,
                      w: 1,
                      x: 0,
                      y: 0,
                    },
                    sm: {
                      h: 1,
                      i: '.$9c854d0d-11d3-41ab-99a7-e4cb146d5e91',
                      moved: false,
                      static: false,
                      w: 1,
                      x: 0,
                      y: 0,
                    },
                  },
                  id: '9c854d0d-11d3-41ab-99a7-e4cb146d5e91',
                  type: 'card_social_link',
                  url: 'https://twitter.com/typedreamhq',
                },
                {
                  children: [
                    {
                      id: '30f920f9-8b88-4445-b783-2055b111f8a1',
                      text: '',
                    },
                  ],
                  data: {
                    bio: 'The Canva of web pages: build pages, link in bios, forms, blogs, shops - no code.',
                    followers: 1524,
                    following: 15,
                    username: '@typedreamhq',
                  },
                  gridProps: {
                    lg: {
                      h: 1,
                      w: 1,
                      x: 1,
                      y: 0,
                    },
                    md: {
                      h: 1,
                      w: 1,
                      x: 1,
                      y: 0,
                    },
                    sm: {
                      h: 1,
                      i: '.$e4a2a053-eb78-44b6-a03d-adc366eaad14',
                      moved: false,
                      static: false,
                      w: 1,
                      x: 0,
                      y: 1,
                    },
                  },
                  id: 'e4a2a053-eb78-44b6-a03d-adc366eaad14',
                  type: 'card_social_link',
                  url: 'https://www.instagram.com/typedreamhq/',
                },
                {
                  children: [
                    {
                      id: 'b9de3f11-c3fe-4986-bc66-5c7015bf649e',
                      text: '',
                    },
                  ],
                  data: {
                    bio: 'The Canva of web pages: build pages, link in bios, forms, blogs, shops - no code.',
                    followers: 1382,
                    following: 30,
                    icon: 'https://image.typedream.com/cdn-cgi/image/width=144,height=144,quality=100,fit=crop/https://api.typedream.com/v0/document/public/66c63598-74bb-4f89-8a5c-611d9805805a_square_cloud_8bit_png.png',
                    title: 'Blog',
                    username: 'typedream.com',
                  },
                  gridProps: {
                    lg: {
                      h: 1,
                      w: 1,
                      x: 2,
                      y: 0,
                    },
                    md: {
                      h: 1,
                      w: 1,
                      x: 2,
                      y: 0,
                    },
                    sm: {
                      h: 1,
                      i: '.$24cb94e6-7811-465b-b2bd-7a87f555538a',
                      moved: false,
                      static: false,
                      w: 1,
                      x: 1,
                      y: 0,
                    },
                  },
                  id: '24cb94e6-7811-465b-b2bd-7a87f555538a',
                  type: 'card_social_link',
                  url: 'https://www.typedream.com/blog',
                },
                {
                  children: [
                    {
                      id: '20bbe723-24a6-4b38-b665-6925a607fbe5',
                      text: '',
                    },
                  ],
                  data: {
                    bio: 'The Canva of web pages: build pages, link in bios, forms, blogs, shops - no code.',
                    followers: 1382,
                    following: 30,
                    icon: 'https://image.typedream.com/cdn-cgi/image/width=144,height=144,quality=100,fit=crop/https://api.typedream.com/v0/document/public/66c63598-74bb-4f89-8a5c-611d9805805a_square_cloud_8bit_png.png',
                    title: 'Typedream',
                    username: 'typedream.com',
                  },
                  gridProps: {
                    lg: {
                      h: 1,
                      w: 1,
                      x: 3,
                      y: 0,
                    },
                    md: {
                      h: 1,
                      w: 1,
                      x: 3,
                      y: 0,
                    },
                    sm: {
                      h: 1,
                      i: '.$4ad6b48a-72ee-4a77-824d-f1614178a571',
                      moved: false,
                      static: false,
                      w: 1,
                      x: 1,
                      y: 1,
                    },
                  },
                  id: '4ad6b48a-72ee-4a77-824d-f1614178a571',
                  type: 'card_social_link',
                  url: 'https://www.typedream.com',
                },
              ],
              gridProps: {
                h: 1,
                i: '.$7aa75ebd-f67f-42e5-990e-c4cdaa226e8c',
                moved: false,
                static: false,
                w: 1,
                x: 2,
                y: 1,
              },
              id: '7aa75ebd-f67f-42e5-990e-c4cdaa226e8c',
              type: 'card_grid_container',
            },
          ],
          cols: 3,
          id: 'da9fg80-b481-45b3-b949-3a53354eb7d1',
          type: 'grid',
        },
      ],
      id: 'c2f7e6e7-1c62-4dd7-b601-613215d15804',
      type: 'root',
      vertical_align: 'align_start',
      vertical_snap_scroll: true,
    },
  ];

  return content;
};
